import React from 'react';
import Slider from '@pwskills/rachnaui/components/Slider';
import { IInstructors } from '@/interfaces/courseDescription';
import MentorCard from './MentorCard';

const MentorCards = ({
  instructors,
  isLinkedInButtonEnabled = false,
  learnersPlacedToBeShown = false,
  industryExpToBeShown = false,
  isSocialIconEnabled = false,
}: {
  instructors: IInstructors[];
  isLinkedInButtonEnabled?: boolean;
  learnersPlacedToBeShown?: boolean;
  industryExpToBeShown?: boolean;
  isSocialIconEnabled?: boolean;
}) => {
  return (
    <Slider
      iconWrapperClass="!p-0 !mx-0"
      wrapperClass="flex flex-col gap-6"
      className="px-1 gap-4 medium:gap-6"
      positionOfSliderInMobile="bottom"
    >
      {instructors?.map((mentor: IInstructors) => (
        <MentorCard
          mentor={mentor}
          key={mentor?._id}
          isLinkedInButtonEnabled={isLinkedInButtonEnabled}
          learnersPlacedToBeShown={learnersPlacedToBeShown}
          industryExpToBeShown={industryExpToBeShown}
          isSocialIconEnabled={isSocialIconEnabled}
        />
      ))}
    </Slider>
  );
};

export default MentorCards;
